// The single definition of "is this the real site".
//
// It lives in its own module, with no Firebase import, so the landing page can
// use it to gate the service worker without pulling the whole SDK into a bundle
// that is otherwise 3 KB. firebaseConfig.js imports it too — one definition, so
// the emulator gate and the service-worker gate cannot drift apart.
//
// Allowlisting production and defaulting everything else to "not production" is
// the safe direction: an unrecognised host gets the emulator and no service
// worker, both of which fail visibly rather than silently talking to live data.
const PRODUCTION_HOSTS = [
  "greatmahabharataquiz.com",
  "www.greatmahabharataquiz.com"
];

export default function isProductionHost() {
  return (
    PRODUCTION_HOSTS.includes(location.hostname) ||
    location.hostname.endsWith(".netlify.app")
  );
}
